import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  AppBar,
  Toolbar,
  IconButton
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../hooks/useTranslation';

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box>
      <AppBar position="static" sx={{ backgroundColor: 'white', color: 'black', boxShadow: 1 }}>
        <Toolbar>
          <IconButton onClick={() => navigate('/')} sx={{ mr: 2 }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
            {t('legal.privacyPolicyTitle')}
          </Typography>
        </Toolbar>
      </AppBar>

      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper elevation={0} sx={{ p: 4, border: '1px solid #e0e0e0' }}>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', mb: 4 }}>
            {t('legal.privacyPolicy')}
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
            {t('legal.lastUpdated')}
          </Typography>

          <Box sx={{ '& > *': { mb: 3 } }}>
            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                {t('legal.companyInfo')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('legal.companyDescription')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('legal.companyAddress')}
              </Typography>
            </Box>

            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                {t('legal.dataCollected')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('legal.dataCollectedDescription')}
              </Typography>
              <Typography component="ul" variant="body1" sx={{ pl: 3 }}>
                <li>{t('legal.identificationInfo')}</li>
                <li>{t('legal.professionalInfo')}</li>
                <li>{t('legal.navigationData')}</li>
                <li>{t('legal.paymentInfo')}</li>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                {t('legal.dataUsage')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('legal.dataUsageDescription')}
              </Typography>
              <Typography component="ul" variant="body1" sx={{ pl: 3 }}>
                <li>{t('legal.provideServices')}</li>
                <li>{t('legal.manageAccount')}</li>
                <li>{t('legal.processPayments')}</li>
                <li>{t('legal.sendCommunications')}</li>
                <li>{t('legal.legalObligations')}</li>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                {t('legal.dataSharing')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('legal.dataSharingDescription')}
              </Typography>
              <Typography component="ul" variant="body1" sx={{ pl: 3 }}>
                <li>{t('legal.stripePayments')}</li>
                <li>{t('legal.firebaseHosting')}</li>
                <li>{t('legal.legalAuthorities')}</li>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                {t('legal.yourRights')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('legal.yourRightsDescription')}
              </Typography>
              <Typography component="ul" variant="body1" sx={{ pl: 3 }}>
                <li>{t('legal.rightAccess')}</li>
                <li>{t('legal.rightRectification')}</li>
                <li>{t('legal.rightErasure')}</li>
                <li>{t('legal.rightPortability')}</li>
                <li>{t('legal.rightObjection')}</li>
                <li>{t('legal.rightLimitation')}</li>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                {t('legal.dataSecurity')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('legal.dataSecurityDescription')}
              </Typography>
            </Box>

            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                {t('legal.dataRetention')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('legal.dataRetentionDescription')}
              </Typography>
            </Box>

            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                {t('legal.contact')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('legal.contactDescription')}
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;